module.exports = __webpack_public_path__ + "static/media/0039.635edc1f.svg";